export default __webpack_public_path__ + "static/media/illus.a1736f92.png";